import OrgDetailsConfig from "./OrgDetailsConfig";
import LateFeeConfig from "./LateFeeConfig";

const AdminConfig = () => (
  <div className="admin-config-page">
    <OrgDetailsConfig />
    <LateFeeConfig />
  </div>
);

export default AdminConfig;
